import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { useDispatch } from 'react-redux';
import VariantGroupsOld from '../variant-groups-old';
import {
  ProductConditionSummary,
  Variant as VariantType,
  VariantGroup,
} from '../../../../types';
import { trackProductVariantClick } from '../tracking';
import { setSelectedVariant } from '../../actions/product';
import RouteContext from '../../../../routes/context';
import { PriceListFilterContext } from '../../price-list-filter-context';
import VariantGroups from '../variant-groups';
import ProductConditions from '../product-conditions';
import * as S from './styles';

const ProductFilters: React.FC<IProductFilterProps> = props => {
  const { market } = useContext(AppContext);
  const { filters, selectedCondition } = useContext(PriceListFilterContext);
  const dispatch = useDispatch();
  const { dispatch: routeDispatch } = useContext(RouteContext);

  const { variantGroups, categoryId, conditions } = props;

  const hasVariantGroups =
    variantGroups &&
    variantGroups.length > 0 &&
    market.productVariantCategories?.find(c => c === categoryId);
  const hasConditions = conditions && !!conditions.length;

  const handleSelectedVariant = (
    group: VariantGroup,
    variant: VariantType | null
  ) => {
    dispatch(setSelectedVariant(variant));
    trackProductVariantClick(group, variant);
    routeDispatch({
      type: 'PRODUCT_VARIANTS',
      variants: variant && variant.id !== 0 ? [variant.id] : null,
      options: { ...filters },
      condition: selectedCondition,
    });
  };

  return (
    <>
      {hasConditions && ( // New Filter handling with conditions
        <S.FiltersWrapper>
          {hasVariantGroups && (
            <VariantGroups
              handleSelectedVariant={handleSelectedVariant}
              variantGroups={variantGroups!}
            />
          )}
          <ProductConditions conditions={conditions} />
        </S.FiltersWrapper>
      )}
      {hasVariantGroups &&
      !hasConditions && ( // Old variants
          <VariantGroupsOld
            handleSelectedVariant={handleSelectedVariant}
            variantGroups={variantGroups!}
          />
        )}
    </>
  );
};

interface IProductFilterProps {
  variantGroups?: VariantGroup[] | null;
  conditions: ProductConditionSummary[];
  categoryId?: string;
}

export default ProductFilters;
